export default __webpack_public_path__ + "c266b6af965af5d6060fcbe86845a0f1.jpg";